import type { Conversation } from '../../../common/types';
import type { NavigationAgentSession } from '../NavigationAgentSessionsContext';

export const getSessionLastMessageTimestamp = (
	conversation: Conversation,
	session?: NavigationAgentSession,
): number | undefined => {
	const stored = Date.parse(conversation.lastMessageTimestamp ?? '');
	if (Number.isFinite(stored)) return stored;
	const native = session?.conversationChannel?.lastMessageTimestamp;
	return typeof native === 'number' && Number.isFinite(new Date(native).getTime())
		? native
		: undefined;
};
